<template>
  <a-card :class="classlist">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <template slot="extra" v-if="!isSpecialMenu">
      <slot name="action-button">
        <a-button :disabled="createDisable" type="primary">
          <router-link :to="{ name: createLink }">
            <a-icon type="plus" />&nbsp;Baru
          </router-link>
        </a-button>
      </slot>
    </template>
    <template slot="extra" v-else>
      <slot name="action-button" v-if="createLink != ''">
        <a-button :disabled="createDisable" type="primary">
          <router-link :to="{ name: createLink }">
            <a-icon type="plus" />&nbsp;Baru
          </router-link>
        </a-button>
      </slot>
    </template>
    <a-tabs type="card" @change="callback">
      <a-tab-pane key="1">
        <span slot="tab">{{ titleTab1 }}</span>
        <a-list
          itemLayout="vertical"
          :dataSource="dataListTab1"
          :pagination="pagination"
          :loading="isLoading"
        >
          <a-list-item
            @click="clickActive && clickKey ? sendClick(item, clickKey) : null"
            :class="item.isRead == '0' ? '' : 'read'"
            slot="renderItem"
            slot-scope="item"
          >
            <router-link
              v-if="readable"
              :to="{ name: manifestLink, params: { id: item.id } }"
            >
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <div>
                    <a href="#">{{ item.title }}</a>
                    <slot :item="item" name="title-extended"> </slot>
                  </div>
                  <div>
                    <Status
                      :status="item.status"
                      :class="isMobile ? 'm-remove' : 'margin-left'"
                    />
                    <slot :item="item" name="title-right"> </slot>
                  </div>
                </a-row>
                <div slot="description">
                  <a-row slot="description" type="flex" justify="space-between">
                    <div :style="isMobile ? 'width:100%' : 'width:50%'">
                      <ul
                        :class="
                          readable ? 'list-wrapper m-remove' : 'list-wrapper'
                        "
                      >
                        <!-- Rework -->
                        <li
                          v-for="(item, index) in item.subdesc"
                          :key="index"
                          class="m-remove"
                        >
                          <span v-if="!Array.isArray(item)">{{ item }}</span>
                          <div
                            v-else
                            v-for="(subItem, index) in item"
                            :key="index"
                          >
                            <h4 class="m-remove">{{ subItem.label }}</h4>
                            <span class="m-text-right m-text w-50 wordwrap">{{
                              subItem.value
                            }}</span>
                          </div>
                        </li>
                      </ul>
                      <p class="m-remove m-top" v-if="item.description">
                        Description : {{ item.description }}
                      </p>
                    </div>
                    <div
                      :style="isMobile ? 'width:100%' : 'width:45%'"
                      :class="isMobile ? 'm-top' : ''"
                    >
                      <div
                        v-if="item.timeline"
                        class="d-flex flex-row justify-between"
                      >
                        <h4 v-if="item.unread" class="m-remove">
                          Workflow Status
                        </h4>
                        <span v-else class="m-remove">Workflow Status</span>
                      </div>
                      <a-timeline class="m-timeline-content margin-top">
                        <a-timeline-item
                          v-for="(timeline, index) in item.timeline"
                          :key="index"
                        >
                          <div class="d-flex flex-row justify-between">
                            <span class="margin-right">{{
                              timeline.actor
                            }}</span>
                            <status
                              :class="isMobile ? 'm-remove' : ''"
                              :status="timeline.status"
                            />
                          </div>
                        </a-timeline-item>
                      </a-timeline>
                    </div>
                  </a-row>
                </div>
              </a-list-item-meta>
            </router-link>
            <router-link
              v-else
              :to="{ name: manifestLink, params: { id: item.id } }"
            >
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <div>
                    <a href="#">{{ item.title }}</a>
                    <slot :item="item" name="title-extended"></slot>
                  </div>
                  <!-- <Status
                  :status="item.status"
                  :class="isMobile ? 'm-remove' : 'margin-left'"
                /> -->
                  <slot :item="item" name="title-right"></slot>
                </a-row>
                <a-row slot="description" type="flex" justify="space-between">
                  <div :style="isMobile ? 'width:100%' : 'width:50%'">
                    <!-- <h4 class="m-text-header-bold">
                    {{ item.title }}
                  </h4> -->
                    <a-tooltip
                      v-if="typeof item.subtitle === 'object'"
                      class="m-tooltip-inner"
                      placement="top"
                      :title="item.subtitle.deskripsi"
                    >
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="d-block">{{ item.subtitle }}</span>
                    <ul class="list-wrapper">
                      <li
                        v-for="(items, index) in item.subdesc"
                        :key="index"
                        class="m-remove"
                      >
                        <span
                          v-if="
                            !Array.isArray(items) && typeof items !== 'object'
                          "
                          >{{ items }}</span
                        >
                        <a-tooltip
                          v-else-if="typeof items == 'object'"
                          class="m-tooltip-inner"
                          placement="top"
                          :title="items.deskripsi"
                        >
                          <span class="m-text-ellipse">{{
                            items.deskripsi
                          }}</span>
                        </a-tooltip>
                        <div
                          v-else
                          v-for="(subItem, index) in items"
                          :key="index"
                        >
                          <div class="d-flex flex-column justify-between">
                            <h4 v-if="item.unread" class="m-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="d-block m-remove">{{
                              subItem.label
                            }}</span>
                            <span class="m-text-right m-text w-50 wordwrap">{{
                              subItem.value
                            }}</span>
                          </div>
                        </div>

                        <template v-if="Array.isArray(items)">
                          <div v-for="(subItem, index) in items" :key="index">
                            <div class="d-flex flex-row justify-between">
                              <h4 v-if="item.unread" class="m-remove">
                                {{ subItem.label }}
                              </h4>
                              <p
                                class="m-remove m-top"
                                v-if="subItem.label == 'description'"
                              >
                                {{ subItem.label }}
                              </p>
                              <span v-else class="d-block m-remove">{{
                                subItem.label
                              }}</span>
                              <span class="m-text-right m-text w-50 wordwrap">{{
                                subItem.value
                              }}</span>
                            </div>
                          </div>
                        </template>
                      </li>
                    </ul>
                    <p class="m-remove m-top" v-if="item.description">
                      {{ item.description }}
                    </p>
                  </div>
                  <div
                    :style="isMobile ? 'width:100%' : 'width:45%'"
                    :class="isMobile ? 'm-top' : ''"
                  >
                    <div
                      v-if="item.timeline"
                      class="d-flex flex-row justify-between"
                    >
                      <h4 v-if="item.unread" class="m-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="m-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item
                        v-for="(timeline, index) in item.timeline"
                        :key="index"
                      >
                        <div class="d-flex flex-row justify-between">
                          <span class="margin-right">{{ timeline.actor }}</span>
                          <status
                            :class="isMobile ? 'm-remove' : ''"
                            :status="timeline.status"
                          />
                        </div>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-row>
              </a-list-item-meta>
            </router-link>
            <div class="actions m-padding-bottom-10">
              <a-button-group ghost v-if="item.status === 'Revised' && !extendedButton" class="m-padding-top-10">
                <!-- <a-button type="primary">
                <router-link
                  :to="{ name: manifestLink, params: { id: item.id } }"
                >
                  <a-icon type="eye" />&nbsp;Manifest
                </router-link>
              </a-button> -->
                <slot
                  :item="item"
                  name="change-button" 
                >
                  <a-button>
                    <router-link
                      :to="{ name: editLink, params: { id: item.id } }"
                    >
                      <a-icon type="edit" />
                      <span>Ubah</span>
                    </router-link>
                  </a-button>
                </slot>
              </a-button-group>

              <a-button-group ghost v-if="extendedButton && item.status === 'Revised'" class="m-padding-top-10">
                <!--            <a-button type="primary">-->
                <!--              <router-link :to="{name: manifestLink, params:{id: item.id}}">-->
                <!--                <a-icon type="eye" />&nbsp;Manifest-->
                <!--              </router-link>-->
                <!--            </a-button>-->
                <slot :item="item" name="change-button">
                  <a-button>
                    <router-link :to="{name: editLink, params: { id: item.id }}">
                      <a-icon type="edit" />
                      <span>Ubah</span>
                    </router-link>
                  </a-button>
                </slot>
              </a-button-group>
            </div>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">
          <span>{{ titleTab2 }}</span>
          &nbsp;<a-badge v-if="showBadgeDraft" :count="showBadgeCount" size="small"/>
        </span>
        <a-list
          itemLayout="vertical"
          :dataSource="dataListTab2"
          :pagination="pagination"
          :loading="isLoading"
        >
          <a-list-item
            @click="clickActive && clickKey ? sendClick(item, clickKey) : null"
            :class="item.isRead == '0' ? '' : 'read'"
            slot="renderItem"
            slot-scope="item"
          >
            <router-link
              v-if="readable"
              :disabled="drafttoRevise" 
              :to="{ name: manifestLink, params: { id: item.id } }"
            >
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <div>
                    <a href="#">{{ item.title }}</a>
                    <slot :item="item" name="title-extended"> </slot>
                  </div>
                  <div>
                    <Status
                      :status="item.status"
                      :class="isMobile ? 'm-remove' : 'margin-left'"
                    />
                    <slot :item="item" name="title-right"> </slot>
                  </div>
                </a-row>
                <div slot="description">
                  <a-row slot="description" type="flex" justify="space-between">
                    <div :style="isMobile ? 'width:100%' : 'width:50%'">
                      <ul
                        :class="
                          readable ? 'list-wrapper m-remove' : 'list-wrapper'
                        "
                      >
                        <!-- Rework -->
                        <li
                          v-for="(item, index) in item.subdesc"
                          :key="index"
                          class="m-remove"
                        >
                          <span v-if="!Array.isArray(item)">{{ item }}</span>
                          <div
                            v-else
                            v-for="(subItem, index) in item"
                            :key="index"
                          >
                            <h4 class="m-remove">{{ subItem.label }}</h4>
                            <span class="m-text-right m-text w-50 wordwrap">{{
                              subItem.value
                            }}</span>
                          </div>
                        </li>
                      </ul>
                      <p class="m-remove m-top" v-if="item.description">
                        Description : {{ item.description }}
                      </p>
                    </div>
                    <div
                      :style="isMobile ? 'width:100%' : 'width:45%'"
                      :class="isMobile ? 'm-top' : ''"
                    >
                      <div
                        v-if="item.timeline"
                        class="d-flex flex-row justify-between"
                      >
                        <h4 v-if="item.unread" class="m-remove">
                          Workflow Status
                        </h4>
                        <span v-else class="m-remove">Workflow Status</span>
                      </div>
                      <a-timeline class="m-timeline-content margin-top">
                        <a-timeline-item
                          v-for="(timeline, index) in item.timeline"
                          :key="index"
                        >
                          <div class="d-flex flex-row justify-between">
                            <span class="margin-right">{{
                              timeline.actor
                            }}</span>
                            <status
                              :class="isMobile ? 'm-remove' : ''"
                              :status="timeline.status"
                            />
                          </div>
                        </a-timeline-item>
                      </a-timeline>
                    </div>
                  </a-row>
                </div>
              </a-list-item-meta>
            </router-link>
            <router-link
              v-else
              :disabled="drafttoRevise" 
              :to="{ name: manifestLink, params: { id: item.id } }"
            >
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <div>
                    <a href="#">{{ item.title }}</a>
                    <slot :item="item" name="title-extended"></slot>
                  </div>
                  <!-- <Status
                  :status="item.status"
                  :class="isMobile ? 'm-remove' : 'margin-left'"
                /> -->
                  <slot :item="item" name="title-right"></slot>
                </a-row>
                <a-row slot="description" type="flex" justify="space-between">
                  <div :style="isMobile ? 'width:100%' : 'width:50%'">
                    <!-- <h4 class="m-text-header-bold">
                    {{ item.title }}
                  </h4> -->
                    <a-tooltip
                      v-if="typeof item.subtitle === 'object'"
                      class="m-tooltip-inner"
                      placement="top"
                      :title="item.subtitle.deskripsi"
                    >
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="d-block">{{ item.subtitle }}</span>
                    <ul class="list-wrapper">
                      <li
                        v-for="(items, index) in item.subdesc"
                        :key="index"
                        class="m-remove"
                      >
                        <span
                          v-if="
                            !Array.isArray(items) && typeof items !== 'object'
                          "
                          >{{ items }}</span
                        >
                        <a-tooltip
                          v-else-if="typeof items == 'object'"
                          class="m-tooltip-inner"
                          placement="top"
                          :title="items.deskripsi"
                        >
                          <span class="m-text-ellipse">{{
                            items.deskripsi
                          }}</span>
                        </a-tooltip>
                        <div
                          v-else
                          v-for="(subItem, index) in items"
                          :key="index"
                        >
                          <div class="d-flex flex-column justify-between">
                            <h4 v-if="item.unread" class="m-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="d-block m-remove">{{
                              subItem.label
                            }}</span>
                            <span class="m-text-right m-text w-50 wordwrap">{{
                              subItem.value
                            }}</span>
                          </div>
                        </div>

                        <template v-if="Array.isArray(items)">
                          <div v-for="(subItem, index) in items" :key="index">
                            <div class="d-flex flex-row justify-between">
                              <h4 v-if="item.unread" class="m-remove">
                                {{ subItem.label }}
                              </h4>
                              <p
                                class="m-remove m-top"
                                v-if="subItem.label == 'description'"
                              >
                                {{ subItem.label }}
                              </p>
                              <span v-else class="d-block m-remove">{{
                                subItem.label
                              }}</span>
                              <span class="m-text-right m-text w-50 wordwrap">{{
                                subItem.value
                              }}</span>
                            </div>
                          </div>
                        </template>
                      </li>
                    </ul>
                    <p class="m-remove m-top" v-if="item.description">
                      {{ item.description }}
                    </p>
                  </div>
                  <div
                    :style="isMobile ? 'width:100%' : 'width:45%'"
                    :class="isMobile ? 'm-top' : ''"
                  >
                    <div
                      v-if="item.timeline"
                      class="d-flex flex-row justify-between"
                    >
                      <h4 v-if="item.unread" class="m-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="m-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item
                        v-for="(timeline, index) in item.timeline"
                        :key="index"
                      >
                        <div class="d-flex flex-row justify-between">
                          <span class="margin-right">{{ timeline.actor }}</span>
                          <status
                            :class="isMobile ? 'm-remove' : ''"
                            :status="timeline.status"
                          />
                        </div>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-row>
              </a-list-item-meta>
            </router-link>
            <div class="actions m-padding-bottom-10">
              <a-button-group v-if="!extendedButton" ghost class="m-padding-top-10">
                <!-- <a-button type="primary">
                <router-link
                  :to="{ name: manifestLink, params: { id: item.id } }"
                >
                  <a-icon type="eye" />&nbsp;Manifest
                </router-link>
              </a-button> -->
                <slot
                  :item="item"
                  name="change-button"
                >
                  <a-button>
                    <router-link
                      :to="{ name: editDraft, params: { id: item.id } }"
                    >
                      <a-icon type="edit" />
                      <span>Ubah</span>
                    </router-link>
                  </a-button>
                </slot>
              </a-button-group>

              <a-button-group v-if="extendedButton" ghost class="m-padding-top-10">
                <!--            <a-button type="primary">-->
                <!--              <router-link :to="{name: manifestLink, params:{id: item.id}}">-->
                <!--                <a-icon type="eye" />&nbsp;Manifest-->
                <!--              </router-link>-->
                <!--            </a-button>-->
                <slot :item="item" name="change-button">
                  <a-button >
                    <router-link :to="{name: editDraft, params: { id: item.id }}">
                      <a-icon type="edit" />&nbsp;Ubah
                    </router-link>
                  </a-button>
                  <!-- <a-button v-if="extendedButtonDeleteDraft" type="danger">
                    <a-icon type="delete" />
                    <span>Delete</span>
                  </a-button> -->
                </slot>
              </a-button-group>
            </div>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import Status from "./Status";

export default {
  name: "DataListTabs",
  props: {
    createDisable: false,
    titleTab1: String,
    titleTab2: String,
    title: String,
    createLink: String,
    manifestLink: String,
    editLink: String,
    editDraft: String,
    dataListTab1: {
      type: Array,
      required: true
    },
    dataListTab2: {
      type: Array,
      required: true
    },
    isSpecialMenu: false,
    isLoading: Boolean,
    readable: Boolean,
    manifestActive: {
      default: true
    },
    extendedButton: false,
    clickActive: {
      default: false
    },
    clickKey: String,
    drafttoRevise: {
      default: false
    },
    extendedButtonDeleteDraft: {
      default: false
    },
    showBadgeDraft: Boolean,
    showBadgeCount: Number
  },
  components: {
    Status
  },
  data() {
    return {
      pagination: {
        onChange: page => {
          // console.log(page);
        },
        pageSize: 5,
        size: "default"
      },
      classlist: "",
      activetab: "1"
    };
  },
  mounted() {
    if (this.isMobile) {
      if (this.readable) {
        this.classlist =
          "m-top d-flex flex-column d-list-wrapper m-card-readable";
      } else {
        this.classlist = "m-top d-flex flex-column m-card-nonreadable";
      }
    } else {
      if (this.readable) {
        this.classlist = "d-flex flex-column d-list-wrapper m-card-readable";
      } else {
        this.classlist = "d-flex flex-column m-card-nonreadable";
      }
    }
  },
  methods: {
    sendClick(item, key) {
      // console.log('test')
      Event.$emit(key, item);
    },
    callback(key) {
      this.activetab = key
      Event.$emit("onTabCLick", key);
    },
  }
};
</script>

<style scoped lang="less"></style>
